module.exports = __webpack_public_path__ + "static/media/IMG_5176.a662c51d.JPG";